export default "__VITE_ASSET__BScLCCZV__"